<template>
  <div>
    <!--<router-view v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"-->
    <router-view
      :topicInfo="topicInfo"
      :topicID="topicID"
      :sid="sid"
      :uid="uid"
      :bg="topicInfo.imgUrl"
      :govImage="govImage"
      :attention="attention"
      :themeColor="themeColor"
      :appName="appName"
      @downApp="downApp"
      @showSwiper="showSwiper"
    ></router-view>
    <swiper :items="pics" v-if="isShowSwiper" :initIndex="initIndex" v-on:close="closeImg"></swiper>
  </div>

</template>
<script>
  // import axios from 'axios'
  import $ from 'jquery'
  import swiper from './components/swiper/swiper'
  import submit from './tool/submit'
  import utils from './tool/utils'
  // import evokeApp from './tool/evokeApp'

  // const _userAgent = window.navigator.userAgent
  // const _agent = _userAgent.indexOf('xkyApp') === -1
  // const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1

  export default {
    data () {
      return {
        topicInfo: {},
        topicID: '',
        discussID: '',
        sid: '',
        uid: '',
        bg: '',
        govImage: '',
        attention: true,
        busy: true,
        page: -1,
        pageSize: 10,
        themeColor: '#13b7f6',
        appName: '',
        downAppHref: '',
        pics: [],
        initIndex: 0,
        isShowSwiper: 0
      }
    },
    beforeMount () {
    },
    created () {
      this.topicID = this.$route.params.topicID
      this.discussID = this.$route.params.discussID
      this.sid = this.$route.params.sid
      const _this = this
      // $.ajaxSetup({
      //   cache: true
      // })
      // $.getScript(`https://oss.newaircloud.com/global/user/${this.$route.params.sid}/mobile/global.js`).then(function (script, textStatus) {
      //   if (typeof gUserConfig !== 'undefined') {
      //     // eslint-disable-next-line no-undef
      //     _this.downAppHref = gUserConfig.downAppUrl
      //     // setTimeout(function () {
      //     //   // eslint-disable-next-line no-undef
      //     //   typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init({
      //     //     ti: document.title || '',
      //     //     aid: _this.discussID ? _this.discussID : _this.topicID,
      //     //     ty: _this.discussID ? '105' : '104',
      //     //     id: _this.discussID ? _this.discussID : _this.topicID
      //     //   })
      //     // }, 200)
      //   }
      // })
      // if (!_this.$route.params.discussID) {
      // axios.get(`/topicApi/getTopicInfo?topicID=${this.topicID}&sid=${this.sid}`)
      submit.getTopicInfo({topicID: _this.topicID, sid: _this.sid})
        .then((response) => {
          _this.topicInfo = response.data
          document.title = _this.topicInfo.title
          if (!_this.isEmptyObject(_this.topicInfo.config)) {
            _this.govImage = submit.handleImgScaleUrl(_this.topicInfo.config.govImage, 'sm')
          }
          try {
            window.sessionStorage.setItem('configDescription', _this.topicInfo.config && _this.topicInfo.config.description || '')
          } catch (e) {
            console.log(e)
          }
        }).catch(function (error) {
          console.log(error)
        })
      // }
      // submit.getConfig({sid: _this.sid})
      //   .then((response) => {
      //     if (typeof response.data.theme !== 'undefined' && response.data.theme.themeColor) {
      //       _this.themeColor = response.data.theme.themeColor
      //       // 主题色设置
      //       document.body.style.setProperty('--themeColor', _this.themeColor)
      //     } else {
      //       _this.themeColor = '#13b7f6'
      //     }
      //     if (typeof response.data.theme !== 'undefined' && response.data.theme.themeGray) {
      //       document.getElementsByTagName('html')[0].className = 'filterClass'
      //     }
      //     if (typeof response.data.appName !== 'undefined' && response.data.appName) {
      //       _this.appName = response.data.appName
      //     }
      //   }).catch(function (error) {
      //   console.log(error)
      // })
      // eslint-disable-next-line no-undef
      _this.themeColor = _themeColor
      // eslint-disable-next-line no-undef
      _this.appName = _appName
      this.fnResize()
      window.onresize = function () {
        if (utils.browser().mobile) {
          _this.fnResize()
        }
      }
    },
    mounted () {
      var $agent = window.navigator.userAgent
      if (!($agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1 || $agent.indexOf('iPhone') > -1) || /(Mobile)/gi.test($agent)) {
        try {
          document.getElementsByTagName('body')[0].style.maxWidth = '7.5rem'
          document.getElementsByTagName('body')[0].style.margin = 'auto'
        } catch (e) {
          console.log(e)
        }
      }
    },
    methods: {
      isEmptyObject (obj) {
        for (let key in obj) {
          return false
        }
        return true
      },
      fnResize: function () {
        var deviceWidth = document.documentElement.clientWidth || window.innerWidth
        if (deviceWidth >= 750) {
          deviceWidth = 750
        }
        if (deviceWidth <= 320) {
          deviceWidth = 320
        }
        // eslint-disable-next-line no-undef,eqeqeq
        if (!utils.browser().mobile && utils.getUrlParam('mobile') != 1 && !/(pc_body_class)/.test(document.body.className)) {
          try {
            document.body.className += ' pc_body_class'
            deviceWidth = 414
          } catch (e) {
            console.log(e)
          }
        }
        // 50px = 1rem
        document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px'
      },
      downApp: function (e) {
        // eslint-disable-next-line no-undef
        if (typeof evokeApp !== 'undefined' && typeof evokeApp.jumpApp === 'function') {
          // eslint-disable-next-line no-undef
          evokeApp.jumpApp()
        } else {
          // 获得下载链接
          try {
            // eslint-disable-next-line no-undef
            var downAppHref = gUserConfig.downAppUrl
            // eslint-disable-next-line no-undef
            var openAppScheme = gUserConfig.openAppSchemes
            // 打开某手机上的某个app应用
            window.location.href = openAppScheme
            // 如果超时就跳转到app下载页
            setTimeout(function () {
              window.location.href = downAppHref
            }, 500)
          } catch (e) {
            // eslint-disable-next-line no-undef
            window.location.href = gUserConfig.downAppUrl
            console.log(e)
          }
        }
      },
      closeImg () {
        this.isShowSwiper = 0
        $('body').css({overflow: 'initial'})
      },
      showSwiper: function (list, index) {
        if (!list) {
          this.closeImg()
          return
        }

        this.pics = list
        this.isShowSwiper = 1
        this.initIndex = index
      }
    },
    components: {
      swiper
    }
  }
</script>
<style>
  :root {
    --themeColor: "#13b7f6"
  }

  body, div, span, header, footer, ul, li, a, p, h1, h2, h3, h4, h5, h6, i, b, textarea, input {
    padding: 0;
    margin: 0;
    list-style: none;
    font-style: normal;
    text-decoration: none;
    box-sizing: border-box;
    /*&:hover {*/
    /*   outline: none;*/
    /* }*/
    word-wrap: break-word;
    font-family: -apple-system, "Noto Sans", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC", "Source Han Sans SC", "Source Han Sans CN", "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;
    visibility: hidden;
    font-size: 0;
    height: 0;
  }

  body {
    /*width: 7.5rem;*/
    width: 100%;
    margin: 0 auto;
    --themeColor: #13b7f6;
  }

  .filterClass {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  }

  .themeColor {
    color: var(--themeColor) !important;
  }

  .themeBgColor {
    background-color: var(--themeColor) !important;
  }
  .pc_body_class{
    width: 414px;
  }
  .pc_body_class .top-banner, .pc_body_class .bottom-open-app {
    width: 414px;
    margin: auto;
  }

  img[lazy=loading] {
    background-color: #eee !important;
    background-size: 15px !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-image: url(data:image/gif;base64,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) !important;
  }

  .wx-launch-app-btn-parent {
    position: relative;
  }

  .wx-launch-app-btn-outer {
    display: inline-block !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto !important;
    opacity: 0 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
    padding: 0 !important;
    font-size: 14px !important;
    line-height: 14px !important;
    z-index: 9999 !important;
  }

  .wx-launch-app-btn-outer > .wx-launch-app-btn {
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .content-images.more_two>img:nth-child(3n+0){
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?8e618dce